import { useParams } from 'react-router-dom';

import ServiceTestTypeGuard from './ServiceTestTypeGuard';
import ServiceTestsListPanel from './ServiceTestsListPanel';

export default function TestsListPage() {
    const { type: group } = useParams();

    return (
        <ServiceTestTypeGuard group={group}>
            {(testTypeArrayObject) => <ServiceTestsListPanel group={group} testTypeArrayObject={testTypeArrayObject} />}
        </ServiceTestTypeGuard>
    );
}
